import React from 'react';

const MainNavStart = () => {
    return (<>
        <div className="logo-print"><img src="/images/print-logo.png" alt="logo" /></div>
        <div className="logo">Business Scape</div></>);
}

export default MainNavStart;
